import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Popover} from 'react-bootstrap'
import Icon from '../../core/components/Icon'
import AgencySelectInput from '../../company/components/AgencySelectInput'
import {loadPatrimony, sendAssociatePatrimonyInAgencyCmd, sendDissociatePatrimonyFromAgencyCmd} from '../actions'
import i18n from '../i18n'
import style from './AssociateDissociatePatrimonyFromAgencyPopover.less'

function agencyFilter(agencies) {
    return (agency) => {
        return agencies.find((a) => a.uid == agency.uid) == null
    }
}

class AssociateDissociatePatrimonyFromAgencyPopover extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _sendAssociateCmd(event, agencyId) {
        const {dispatch, onHide} = this.props
        
        event.preventDefault()
        dispatch(sendAssociatePatrimonyInAgencyCmd(agencyId)).then(() => {
            return dispatch(loadPatrimony())
        }).then(() => {
            this.setState({selectedAgency: null})
        }).catch(() => {
            this.setState({selectedAgency: null})
        })
    }

    _sendDissociateCmd(event, agency) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(sendDissociatePatrimonyFromAgencyCmd(agency.uid)).then(() => {
            return dispatch(loadPatrimony())
        })
    }

    render() {
        const {dispatch, authenticated, patrimony, onHide, ...others} = this.props
        const {selectedAgency} = this.state

        const agencyField = {
            value: selectedAgency || '',
            onChange: (event) => {
                const selectedAgency = event.target.value
                this.setState({selectedAgency})
                this._sendAssociateCmd(event, selectedAgency)
            }
        }

        return (
            <Popover
                title={i18n.agencies}
                {...others}>
                    <ul className={style.agencyGroup}>
                        {patrimony.agencies.map((agency) => (
                            <li key={agency.uid}>
                                <a
                                    href=''
                                    className={style.dissociate}
                                    onClick={(e) => this._sendDissociateCmd(e, agency)}>
                                    <Icon icon='minus' size='xs' />
                                </a>
                                <p>{agency.label}</p>
                            </li>
                        ))}
                    </ul>
                    <form>
                        <AgencySelectInput
                            user={authenticated}
                            company={patrimony.company}
                            disable={(a) => !!patrimony.agencies.find((pa) => a.uid == pa.uid)}
                            name='agency'
                            {...agencyField}>
                            <option value=''>{i18n.addAgency}</option>
                        </AgencySelectInput>
                    </form>
                    <ButtonToolbar>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
            </Popover>
        )
    }
}

AssociateDissociatePatrimonyFromAgencyPopover = connect((state) => ({
    patrimony: state.patrimony.patrimony,
    authenticated: state.user.authenticated
}))(AssociateDissociatePatrimonyFromAgencyPopover)

export default AssociateDissociatePatrimonyFromAgencyPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/AssociateDissociatePatrimonyFromAgencyPopover.js